// extracted by mini-css-extract-plugin
module.exports = {"container":"SM9Jhp","link":"_2NZz1S","icon":"_3kJb2j","text":"_1BtCWN"};